import React, { useCallback, useEffect, useState } from 'react';
import ECargoLogoAndBlurbView from '../../Common/Components/ECargoLogoAndBlurbView.jsx';
import QueryString from 'query-string';
import LoadingSpinnerView from '../../../Common/Components/LoadingSpinnerView.jsx';

import { usernameChanged } from '../Redux/SignInSlice';
import { signInWithPassword, getUserNameWithSessionKey } from '../Redux/SignInApi';

import type { ChangeEventHandler, ChangeEvent, MouseEventHandler, MouseEvent } from 'react';
import type { AuthsRootState } from '../../Redux/AuthsStore';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom-v5-compat';
import { useAuthsDispatch } from "../../Redux/AuthsHooks";

export default function AuthsSignInPageView() {
    const dispatch = useAuthsDispatch();
    const location = useLocation();
    const userEmailAddress = useSelector((state: AuthsRootState) => state.signIn.userEmailAddress);
    const authenticatingUser = useSelector((state: AuthsRootState) => state.signIn.authenticatingUser);
    const [ userPassword, setUserPassword ] = useState('');

    const getUrlParameters = useCallback(() => {
        let returnUrl = undefined;
        let sessionKey = undefined;

        if(location?.search) {
            const params = QueryString.parse(location.search);
            if(params.ReturnUrl) {
                // Since the returnUrl also contains a query string, do some hackity things to turn it into
                // another query string.
                returnUrl = params.ReturnUrl as string;
                const sessionKeyParamString = returnUrl.slice(returnUrl.indexOf("?"));
                sessionKey = QueryString.parse(sessionKeyParamString).SK as string;
            }
        }

        return ({ returnUrl, sessionKey });
    }, [location.search]);

    useEffect(() => {
        const { sessionKey } = getUrlParameters();
        if(sessionKey) {
            dispatch(getUserNameWithSessionKey(sessionKey));
        }
    }, [dispatch, getUrlParameters]);

    const handleUserEmailAddressChange: ChangeEventHandler = (event: ChangeEvent<HTMLInputElement>) =>
        dispatch(usernameChanged(event.target.value));

    const handleUserPasswordChange: ChangeEventHandler = (event: ChangeEvent<HTMLInputElement>) =>
        setUserPassword(event.target.value);

    const handleSignIn: MouseEventHandler<HTMLButtonElement> = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        const { returnUrl } = getUrlParameters();
        dispatch(signInWithPassword({ username: userEmailAddress, password: userPassword, returnUrl }));
    };

    const childElement = authenticatingUser ? (
        <div className='center'>
            <LoadingSpinnerView inline={true} />
        </div>
    ) : (
        <div className="login">
            <form>
                <div className="details">
                    <label>Login</label>
                    <input id="emailAddress" type="text" value={userEmailAddress} onChange={handleUserEmailAddressChange} autoFocus />

                    <label>Password</label>
                    <input id="password" type="password" value={userPassword} onChange={handleUserPasswordChange} />
                </div>
                <div className="links">
                    <button
                        id="login"
                        type="submit"
                        className="primary button"
                        onClick={handleSignIn} >
                        Log in
                    </button>
                    <Link id="recoverAccountPageLink" to="/App/Auths/RecoverAccount">Forgotten your password?</Link>
                </div>
            </form>
        </div>
    );

    return (
        <ECargoLogoAndBlurbView>{
            childElement
        }</ECargoLogoAndBlurbView>
    );
}
